module.exports = __webpack_public_path__ + "img/logo.dc27ff69.png";